export default {
  overlay: {
    base: {
      bg: 'primary'
    }
  },
  wrapper: {
    base: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      pt: 'md'
    }
  }
};